<template>
    <div class="fs5-quick-links">
        <fs5-section-header :view="view.header" :showTooltip="view.header.showTooltip"/>
        <div class="fs5-quick-links-button">  
            <fs5-button 
                v-for="(item, index) in view.buttons"
                :key="index"
                :label="item.label"
                :btn-type="item.btnType"
                :text-transform-type="item.textTransformType"
                @clicked="callToggleFunction(item.callback)"
            ></fs5-button>
        </div>

        <!-- modal autoresponder -->
        <autoresponder-v5 @toggleAutoresponder="toggleModalAutoresponderEventListener"/>

        <!-- modais de dominio incluidos no arquivo global modals.phtml -->
    </div>
</template>

<script>
    export default {
        name: 'fs5-quick-links',
        props: ['view'],
        data: function() {
            return {
                //autoresponder
                openModalAutoresponder: false,

                //modais de dominio
                openModalConnectFunnels: false,
                openModalDisconnectFunnels: false,
                openModalDomainNS: false,

                pageLoaded: false,
                loading: true,
                calledOpen: false,
                
                // params
                openTool: null,
                'connected-domain': null
            }
        },
        methods: {
            callToggleFunction(functionName){
                this[functionName]()
            },
            // toggle modal autoresponder event listener
            toggleModalAutoresponderEventListener() {
                this.openModalAutoresponder = !this.openModalAutoresponder
                if(this.openModalAutoresponder){
                    $('#autoresponder').modal('show')
                } else {
                    $('#autoresponder').modal('hide')
                }
            },
            // toggle Modal Connect Funnels  event listener
            toggleModalConnectFunnelsEventListener() {
                this.openModalConnectFunnels = !this.openModalConnectFunnels
                if(this.openModalConnectFunnels){
                    $('#modalConnectFunnels').modal('show')
                }
            },

            // toggle Modal disconnect Funnels  event listener
            toggleModalDisconnectFunnelsEventListener() {
                this.openModalDisconnectFunnels = !this.openModalDisconnectFunnels
                if(this.openModalDisconnectFunnels){
                    $('#modalDisconnectFunnels').modal('show')
                }
            },
            // toggle Modal domain DNS  event listener
            toggleModalModalDomainDNSEventListener() {
                this.openModalDomainNS = !this.openModalDomainNS
                if(this.openModalDomainNS){
                    $('#modalDomainNS').modal('show')
                }
            },
            openModalbySideMenu(){
                // OPEN MODAL
                this.openTool = new URL(location.href).searchParams.get('opentool');
                if(this.openTool !== undefined && this.openTool !== null) {
                    switch (this.openTool) {
                        case 'autoresponder':
                            this.toggleModalAutoresponderEventListener();
                            break;
                        case 'connect_domain':
                            this.toggleModalConnectFunnelsEventListener()
                            break;
                        case 'disconnect_domain':
                            this.toggleModalDisconnectFunnelsEventListener();
                            break;
                        case 'name_servers':
                            this.toggleModalModalDomainDNSEventListener()
                            break;
                    }
                    this.calledOpen = true
                }
                
                this['connected-domain'] = new URL(location.href).searchParams.get('connected-domain');
                if(this['connected-domain'] !== undefined && this['connected-domain'] !== null && !this.openModalDomainNS) {
                    this.toggleModalModalDomainDNSEventListener()
                    this.calledOpen = true
                }
            }
        },
        mounted() {
            let vm = this

            $(() => {
                vm.pageLoaded = true
                
                // hide modal autoresponder event listener
                // $('#autoresponder').on('hidden.bs.modal', function() {
                //     vm.toggleModalAutoresponderEventListener()
                // })

                // hide modal connect funnels event listener
                $('#modalConnectFunnels').on('hidden.bs.modal', vm.toggleModalConnectFunnelsEventListener)

                // hide modal disconnect funnels event listener
                $('#modalDisconnectFunnels').on('hidden.bs.modal', vm.toggleModalDisconnectFunnelsEventListener)

                // hide modal domain dns event listener
                $('#modalDomainNS').on('hidden.bs.modal', vm.toggleModalModalDomainDNSEventListener)
            })
        },
        watch: {
            pageLoaded: function(newVal, oldVal) {
                if( !this.calledOpen && newVal) {
                    this.openModalbySideMenu()
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../../../../scss/extras/_variables';
    .fs5-quick-links{
        font: inherit;
        .fs5-quick-links-button{
            font: inherit;
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(10px, 1fr));
            grid-template-rows: auto;
            justify-content: stretch;
            align-items: center;

            column-gap: 1.8em;
        }
    }

    @media screen and (max-width: 500px){
        .fs5-quick-links{
            .fs5-quick-links-button{
                grid-template-columns: 1fr;
                row-gap: 1em;

                &:last-child{
                    margin-top: 1em;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// resources/office/js/components/franchise_v5/affiliate_dashboard/quick_links/index.vue